import { WindowService } from '@propertyfinder/pf-frontend-common/src/service/window/service';
import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';

import { PropertyPageSocialShareViewStore } from 'common/module/property-page-social-share/view-store';
import { StatsService } from 'common/service/stats/service';
import { FormPropertyShareViewFactory } from 'desktop/module/form/property-share/view.factory';

const propertyPageSocialShareService = new PropertyPageSocialShareViewStore(
  EventEmitterFactory(),
  StatsService(),
  FormPropertyShareViewFactory(),
  WindowService()
);

export function PropertyPageSocialShareViewService(): PropertyPageSocialShareViewStore {
  return propertyPageSocialShareService;
}
